import { BaseEntity } from "@planard/@core/base/BaseEntity";

export class Plan extends BaseEntity {
  rows?: any[];
}
